<script>
export default {
  name: "ClaimsSectionContainer",
  props: {
    errors: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showErrors: false,
    };
  },
  computed: {
    sectionErrors() {
      const errors = {}
      for(const [key, value] of Object.entries(this.errors)) {
        if (key.startsWith(this.$attrs.id)) {
          errors[key] = value;
        }
      }
      return errors;
    },
  },
};
</script>

<template>
  <div>
    <div
      :style="{
        height: Object.keys(sectionErrors).length > 0 ? 'auto' : '0',
        transition: 'height 0.3s ease',
        overflow: 'hidden',
      }"
    >
      <div
        class="text-negative-800 border border-negative-400 bg-negative-50"
      >
        <button
          type="button"
          class="text-center text-xs font-bold uppercase tracking-wide w-full border-b-2 border-negative-400 py-2 block focus:outline-none text-negative-800"
          style="transition: all 0.2s ease-in-out; margin-bottom: -2px;"
          @click="showErrors = !showErrors"
        >
          <template v-if="showErrors">
            &uparrow; {{ Object.keys(sectionErrors).length }} error(s) &uparrow;
          </template>
          <template v-else>
            &downarrow; {{ Object.keys(sectionErrors).length }} error(s) &downarrow;
          </template>
        </button>
        <ol
          class="text-negative-500 overflow-hidden text-sm leading-loose"
          :style="{
            height: showErrors ? 'auto' : '0',
            transition: 'height 0.3s ease',
          }"
        >
          <li
            v-for="(error, key) in sectionErrors"
            :key="key"
          >
            <template v-if="error.length == 1">
              {{ error[0] }}
            </template>
            <ul v-else>
              <li
                v-for="(err, index) in error"
                :key="index"
              >
                {{ err }}
              </li>
            </ul>
          </li>
        </ol>
      </div>
    </div>
    <table>
      <slot name="header" />
      <slot />
      <slot name="footer" />
    </table>
    <div
      v-if="$slots.gutter"
      class="gutter"
    >
      <slot name="gutter" />
    </div>
  </div>
</template>

<style lang="styl" scoped>

div
  scroll-margin-top 8rem;
  &:target
    outline 2px dashed #15A5BB;
    outline-offset 1rem;

::v-deep

  table
    @apply w-full border-collapse;

    th, td
      @apply px-4 py-2;

    thead
      @apply text-left;

    tbody
      @apply bg-white;
      box-shadow 0 .5rem 1rem rgba(0, 0, 0, 0.1)

      td
        @apply border border-grey-200;
        &:has(input)
          @apply p-0;

        &:has(.currency)
          @apply pl-4;

        input
          @apply w-full h-full px-4 py-2;
          border none;
          box-shadow none;
          outline none;

    .currency
      @apply w-full flex justify-between items-center;
      font-variant-numeric: tabular-nums;

  .gutter
    @apply text-sm mt-4 px-4;

    a
      @apply text-primary-500;

      &:hover
        @apply text-primary-700;

  .remove
    @apply text-negative-500 bg-negative-100 rounded-full w-6 h-6 flex items-center justify-center text-lg font-bold;

    &:hover
      @apply text-negative-700 bg-negative-200;

  .empty
    @apply text-center text-grey-500 py-4 text-xl font-semibold py-2;


  .has-error
    @apply bg-negative-50 text-negative-800;
    input
      @apply bg-negative-50 text-negative-800;

</style>
